import { Vertical, Texto } from '@gravitate-js/excalibrr'
import { Form, InputNumber } from 'antd'
import { getHelperText, getPercentageMessage } from '../utils'
import { InvoiceDetail } from '@/api/useFreight/types'
import { TransactionDetail } from '../../columnDefs'
import { AccessorialOptionType } from '../types'

type TotalInputProps = {
  selectedAccessorial:
    | {
        feeType: string
        isPercentageBased: boolean
        accessorial: TransactionDetail | InvoiceDetail | AccessorialOptionType | undefined
      }
    | undefined
  isEditing: boolean
}

export function TotalInput({ selectedAccessorial, isEditing }: TotalInputProps) {
  return (
    <Vertical gap={8}>
      {isEditing ? (
        <>
          <Form.Item
            name='total'
            label='Total'
            rules={[{ required: true, message: 'Please enter a total' }]}
            style={{ marginBottom: 0 }}
          >
            <InputNumber
              type='number'
              placeholder='Enter total'
              addonBefore={<Texto>$</Texto>}
              min={0}
              style={{ width: '100%', flex: 1 }}
            />
          </Form.Item>
          <Texto appearance='hint' className='px-2'>
            {getHelperText('total', !!selectedAccessorial?.isPercentageBased)}
          </Texto>
          <Vertical className='px-2'>
            <Texto>Rate</Texto>
            <Texto>{((selectedAccessorial?.accessorial?.rate ?? 0) * 100).toFixed(3)}%</Texto>
          </Vertical>
        </>
      ) : (
        <>
          {selectedAccessorial?.feeType && (
            <Texto appearance='hint' className='px-2'>
              {getPercentageMessage(selectedAccessorial.feeType)}
            </Texto>
          )}
        </>
      )}
    </Vertical>
  )
}
